/* istanbul ignore file -- api file */
import { useServiceUrls } from '@ori/configuration-manager';
import { useHeaders } from '@ori/presentation-http';
import { useCallback } from 'react';

import { getSearchPreviewData } from '../api';
import { SEARCH_PREVIEW_PRODUCTS_LIMIT } from '../constants';
import { mapSearchPreviewQuery } from '../utils';

export const useGetSearchPreviewData = () => {
  const { graphQlNetUrl } = useServiceUrls(['graphQlNet']);
  const { headers } = useHeaders();

  const getData = useCallback(
    async (query: string) => {
      const response = await getSearchPreviewData({
        graphQlNetUrl,
        headers,
        query,
        limit: SEARCH_PREVIEW_PRODUCTS_LIMIT,
      });

      return mapSearchPreviewQuery(response);
    },
    [graphQlNetUrl, headers],
  );

  return { getData };
};
